module.exports = __webpack_public_path__ + "static/media/lambda.5898ab5d.png";